import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { Link, useParams,useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";



const TopicList = () => {

  const { courseId } = useParams(); // route: /topics/:courseId
  const [topics, setTopics] = useState([]);
  const [courseName, setCourseName] = useState("");

  const { search } = useLocation();
    const searchparams = new URLSearchParams(search);
    const param = searchparams.get("course_id");


    const [toggle, setToggle] = useState(false);

const [formData, setFormData] = useState({
  topic_name: "",
  description: "",
  youtube_link: "",
  attachement_file: []
});

  useEffect(() => {
    fetchTopics();
  }, []);

  const fetchTopics = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/topic_list/${param}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      setTopics(res.data.data.data);
      setCourseName(res.data.course_name || "Course");

    } catch (err) {
      console.log(err);
    }
  };


  const handleSubmit = async (e) => {

  e.preventDefault();

  const formDataObj = new FormData();
  formDataObj.append("course_id", param);
  formDataObj.append("topic_name", formData.topic_name);
  formDataObj.append("description", formData.description);
  formDataObj.append("youtube_link", formData.youtube_link);

  // Multiple files
  for (let i = 0; i < formData.attachement_file.length; i++) {
    formDataObj.append("attachement_file[]", formData.attachement_file[i]);
  }

  axios.post(
    API_BASE_URL + '/add_topic',
    formDataObj,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data"
      },
    }
  ).then(response => {

    var status = response.data.status;

    if (status === "success") {

      toast.success(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });

      setToggle(false);
      fetchTopics();

      setFormData({
        topic_name: "",
        description: "",
        youtube_link: "",
        attachement_file: []
      });

    } 
    else if (status === "error") {

      toast.error(response.data.message, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });
    }

  }).catch(error => {

    toast.error(
      error.response?.data?.message || "Something went wrong",
      {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      }
    );

  });
};

  return (
    <>
      <ToastContainer />

      <div className="container-fluid">

        {/* Header Card */}
       <div className="card-header d-flex justify-content-between align-items-center">
  <span style={{ color: "blue", fontWeight: "600" }}>
    {courseName.toUpperCase()}
  </span>

  <button
    className="btn btn-primary"
    onClick={() => setToggle(!toggle)}
  >
    <i className="fe fe-plus mr-2" />
    {toggle ? "Close" : "Add"}
  </button>
</div>


{toggle && (
  <div className="card mb-4">
    <div className="card-header">
      <h3 className="card-title" style={{ color: "#e96827" }}>
        ADD TOPIC
      </h3>
    </div>

    <div className="card-body">
      <form onSubmit={handleSubmit}>
        <div className="row">

          <div className="col-md-6">
            <div className="form-group">
              <label>Topic Name *</label>
              <input
                type="text"
                className="form-control"
                value={formData.topic_name}
                onChange={(e) =>
                  setFormData({ ...formData, topic_name: e.target.value })
                }
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Youtube Url</label>
              <input
                type="text"
                className="form-control"
                value={formData.youtube_link}
                onChange={(e) =>
                  setFormData({ ...formData, youtube_link: e.target.value })
                }
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="form-group">
              <label>Description</label>
              <textarea
                className="form-control"
                rows="5"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>Attachment (Multiple)</label>
              <input
                type="file"
                className="form-control"
                multiple
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    attachement_file: e.target.files
                  })
                }
              />
              <small>Upload only PDF, DOC, PPT</small>
            </div>
          </div>

        </div>

        <div className="mt-3">
          <button className="btn btn-primary">
            Save
          </button>
        </div>

      </form>
    </div>
  </div>
)}
          
        {/* Topic Table */}
        <div className="card">
          <div className="card-header">
            <h6 className="card-title" style={{ color: "#e96827" }}>
              List All Topic
            </h6>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Topic Name</th>
                  </tr>
                </thead>

                <tbody>
                  {topics.length > 0 ? (
                    topics.map((topic, index) => (
                      <tr key={index}>
                        <td>
                          <Link to={`/EditTopic?id=${topic.id}`}>
                            <i className="fe fe-edit mr-2 text-info" style={{ fontSize: "15px" }} />
                          </Link>

                          <Link to={`/TopicDetails?id=${topic.id}`}>
                            <i className="fe fe-eye text-primary mr-2 text-info" style={{ fontSize: "15px" }}/>
                          </Link>


                          <Link to={`/QuestionList?id=${topic.id}`}>
                           <i class="fe fe-help-circle text-primary" style={{ fontSize: "15px" }} />
                          </Link>
                        </td>

                        <td>{topic.topic_name}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center">
                        No Topics Found
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default TopicList;